// client/src/utils/categoryTree.js

// Ordonne les catégories : chaque catégorie principale suivie de ses sous-catégories.
// Retourne une liste plate [{ ...category, depth }] (depth 0 = principale, 1 = sous-catégorie).
export const orderCategoriesHierarchically = (categories) => {
  const byName = (a, b) => a.name.localeCompare(b.name);
  const childrenOf = {};
  categories.forEach((c) => {
    if (c.parentId) {
      childrenOf[c.parentId] = childrenOf[c.parentId] || [];
      childrenOf[c.parentId].push(c);
    }
  });

  const out = [];
  categories
    .filter((c) => !c.parentId)
    .sort(byName)
    .forEach((top) => {
      out.push({ ...top, depth: 0 });
      (childrenOf[top.id] || []).sort(byName).forEach((child) => out.push({ ...child, depth: 1 }));
    });

  // Sécurité : sous-catégories dont le parent n'existe plus (affichées au niveau principal).
  categories
    .filter((c) => c.parentId && !categories.some((p) => p.id === c.parentId))
    .sort(byName)
    .forEach((orphan) => out.push({ ...orphan, depth: 0 }));

  return out;
};

// Préfixe d'indentation pour une <option> selon la profondeur.
export const optionPrefix = (depth) => (depth > 0 ? '  ↳ ' : '');
